import { ConstanteGlobal } from "../config/constanteGlobal";
import { FiltroBasico } from "../models/basico";
import { ModeloSopRegion } from "../models/sopRegion";
import { Repositorio } from "./repositorio";

export class FiltroSopBusinesUnit extends FiltroBasico<ModeloSopRegion> implements Partial<ModeloSopRegion> {
  
}

export class RepositorioSopRegion extends Repositorio<ModeloSopRegion> {
  constructor() {
    super(ConstanteGlobal.SOP_REGION);
  }
}
